<template>
  <div class="personal_center">
    <!-- 顶部 -->
    <header>
      <div class="inner">
        <div class="back">
          <div @click="toHome">首页</div>
        </div>
        <div class="center">
          个人中心
        </div>
        <div class="img">
          <img src="../../assets/head.png" alt="" />
        </div>
      </div>
    </header>
    <!-- 主体部分 -->
    <main>
      <ul class="menu-title">
        <li :class="{ color: bigType == 1 }" @click="menuClick(1)">我的收藏</li>
        <li :class="{ color: bigType == 2 }" @click="menuClick(2)">我的购买</li>
        <li :class="{ color: bigType == 3 }" @click="menuClick(3)">我的下载</li>
      </ul>
      <section>
        <!-- 我的下载 -->
        <div class="myDown" v-if="bigType == 3">
          <div class="seach">
            <span>全部下载</span>
            <el-date-picker v-model="seachDate" @change="seachClick" size="small" type="daterange" range-separator="-"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
          <div class="content">
            <div class="item" v-for="(item, index) in downList" :key="index">
              <div class="img" @click="clickPopup(item, item.id)">
                <img src="../../assets/02.jpg" alt="" />
              </div>
              <div class="right">
                <div class="text" @click="clickPopup(item, item.id)">
                  {{ item.resource_name }}
                </div>
                <div class="icon">
                  <i class="el-icon-download" @click="download(item)"></i>
                  <i class="el-icon-delete" @click="cancelDown(item.id,item.product_id)"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination @size-change="SizeChange($event,3)" @current-change="CurrentChange($event,3)"
              :current-page="downPage" :page-sizes="[10, 20, 50, 100]" layout="total, prev, pager, next, jumper"
              :total="downTotal">
            </el-pagination>
          </div>
        </div>
        <!-- 收藏/购买 -->
        <el-tabs v-model="Type" v-else @tab-click="seachClick('tabclick')">
          <el-tab-pane :label="item.label" :name="item.type" v-for="(item, index) in Tabs" :key="index">
            <div class="seach">
              <el-date-picker v-model="seachDate" @change="seachClick" size="small" type="daterange" range-separator="-"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <div class="content">
              <div class="item" v-for="(item2, index2) in dataList" :key="index2">
                <div class="imageBox">
                  <img @click="clickPopup(item, item2.product_id)" :src="item2.image" />
                </div>

                {{item2.title}}
                <div class="cancel" @click="cancelCollect(item2.product_id)" v-show="show_collet">
                  <i class="is_collect el-icon-star-on"></i>
                </div>
              </div>

            </div>
            <div class="pagination">
              <el-pagination @size-change="SizeChange($event,bigType)" @current-change="CurrentChange($event,bigType)"
                :current-page="downPage" :page-sizes="[10, 20, 50, 100]" layout="total, prev, pager, next, jumper"
                :total="downTotal">
              </el-pagination>
            </div>

            <!-- 推荐 -->
            <!-- <div class="recommend">
              <div class="title">精选推荐</div>
              <div class="recommend_content">
                <img src="../../assets/08.jpg" v-for="(item, index) in 3" :key="index" />
              </div>
            </div> -->
          </el-tab-pane>
        </el-tabs>
        <!-- 下载 -->
        <downloadProduct ref="myDown" :dialogStatus="down.dialog" @close="close"></downloadProduct>
      </section>
    </main>
  </div>
</template>

<script>
import downloadProduct from '../../components/downloadProduct/downloadProduct'
import {
  getCollect,
  getOrder,
  getDownloadList,
  toggleCollect,
  editDownloadRecord
} from '../../api/index.js'
export default {
  data () {
    return {
      value: '',
      keyword: '',
      bigType: 1,
      Type: '1',
      show_collet: true,
      Tabs: [
        {
          type: '1',
          label: '模板',
          dialog: false
        },
        {
          type: '2',
          label: '字体',
          dialog: false
        },
        {
          type: '3',
          label: '动画',
          dialog: false
        },
        {
          type: '4',
          label: '视频',
          dialog: false
        },
        {
          type: '5',
          label: '音频',
          dialog: false
        },
        {
          type: '6',
          label: '3D模型',
          dialog: false
        },
        {
          type: '7',
          label: '音效',
          dialog: false
        }
      ],
      hotSeach: [
        {
          name: '热门'
        },
        {
          name: '办公'
        },
        {
          name: '自然'
        },
        {
          name: '娱乐'
        }
      ], // 热门搜索数据
      seachDate: ['', ''],
      dataList: [],
      product_id: 0, // 商品id
      down: { dialog: false }, // 下载参数
      downPage: 1,
      downPageSize: 10,
      downList: [],
      downTotal: 0
    }
  },
  components: {
    downloadProduct
  },
  created () {
    this.resCollect('1')
  },
  methods: {
    menuClick (bigtype) {
      this.resetPage()
      if (bigtype == 1) this.resCollect('1')
      if (bigtype == 2) this.resOrder('1')
      if (bigtype == 3) this.resDownLoad()
      // if (bigtype == 4) this.activationCode()
    },
    toHome () {
      this.$router.push({ path: '/home' })
    },
    // 搜索
    search () {
      this.$router.push({
        path: '/search?keyword=' + this.keyword + '&type=' + this.value
      })
    },
    // 点击热门搜索
    hotClick (val) {
      this.keyword = val
      setTimeout(() => {
        this.$router.push({
          path: '/search?keyword=' + val + '&type=' + this.value
        })
      })
    },
    // 窗口
    clickPopup (item, id) {
      this.$router.push({
        path: '/product_detail',
        query: { type: item.type, product_id: id }
      })
    },
    // 下载
    download (details) {
      details.dialog = true
      this.$forceUpdate()
      this.down = details
      this.down.id = ''
      this.$refs.myDown.download(this.down)
    },
    // 关闭下载
    close () {
      this.down.dialog = false
      this.$forceUpdate()
    },
    resetPage () {
      this.downPage = 1
      this.downPageSize = 10
    },
    // -------------------- 接口
    // 我的收藏
    resCollect (type) {
      this.bigType = 1
      this.Type = type
      getCollect(
        {
          type: type,
          offset: (this.downPage - 1) * this.downPageSize,
          length: this.downPageSize,
          date_start: this.seachDate[0],
          date_end: this.seachDate[1]
        },
        (res) => {
          // console.log(res.result.data)
          this.show_collet = true
          this.dataList = res.result.data
          this.dataList.forEach((item) => {
            if (type == 5 || type == 7) {
              item.image = require('../../assets/dish.png')
            } else {
              item.image = this.$imageUrl + item.image
            }
          })
          this.downTotal = res.result.total
        }
      )
    },
    // 取消收藏
    cancelCollect (id) {
      toggleCollect(
        {
          collect: 0,
          product_id: id
        },
        (res) => {
          this.resCollect(this.Type)
        }
      )
    },
    // 我的购买
    resOrder (type) {
      this.bigType = 2
      this.Type = type
      getOrder(
        {
          type: type,
          offset: (this.downPage - 1) * this.downPageSize,
          length: this.downPageSize,
          date_start: this.seachDate[0],
          date_end: this.seachDate[1]
        },
        (res) => {
          this.show_collet = false
          this.dataList = res.result.data
          this.downTotal = res.result.total
          this.dataList.forEach((item) => {
            if (type == 5 || type == 7) {
              item.image = require('../../assets/dish.png')
            } else {
              item.image = this.$imageUrl + item.order_case.image
            }
            item.title = item.order_case.product_title
            item.product_id = item.order_case.product_id
          })
        }
      )
    },
    // 我的下载
    resDownLoad () {
      this.bigType = 3
      getDownloadList(
        {
          offset: (this.downPage - 1) * this.downPageSize,
          length: this.downPageSize,
          status: '1,2' // '1,2,3',没传拿全部
        },
        (res) => {
          this.downList = res.result.data
          this.downTotal = res.result.total
        }
      )
    },
    // 取消下载
    cancelDown (id, product_id) {
      editDownloadRecord(
        {
          id: id,
          product_id: product_id,
          status: 3
        },
        (res) => {
          this.resDownLoad(this.Type)
        }
      )
    },
    // 下载--换页
    CurrentChange (e, index) {
      this.downPage = e
      if (index == '1') this.resCollect('1')
      if (index == '2') this.resOrder('1')
      if (index == '3') this.resDownLoad()
    },
    // 下载--换长度
    SizeChange (e, index) {
      this.downPageSize = e
      if (index == '1') this.resCollect('1')
      if (index == '2') this.resOrder('1')
      if (index == '3') this.resDownLoad()
    },
    // tab栏切换/日期搜索
    seachClick (type = '') {
      if (type === 'tabclick') {
        this.seachDate = ['', '']
        this.resetPage()
      }
      if (this.bigType === 1) this.resCollect(this.Type)
      else this.resOrder(this.Type)
    },
    // // 我的激活码
    // activationCode () {
    //   this.bigType = 4
    //   activationCode(
    //     {
    //       offset: (this.downPage - 1) * this.downPageSize,
    //       length: this.downPageSize,
    //       status: '1,2' // '1,2,3',没传拿全部
    //     },
    //     (res) => {
    //       this.downList = res.result.data
    //       this.downTotal = res.result.total
    //     }
    //   )
    // },
  }
}
</script>

<style scoped lang="scss">
.personal_center {
  min-width: 864px;
  width: 100%;
  min-height: 100vh;
  background-color: #f4f4f4;
  header {
    width: 100%;
    max-width: 1080px;
    margin: 0 auto;
    height: 80px;
    .inner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 80px;
      max-width: 1080px;
      margin: 0 auto;
      box-sizing: border-box;
      min-width: 864px;
      padding: 0 3%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      box-shadow: 0 1px 1px #e0e0e0;
      z-index: 1000;
    }

    .back {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      height: 100%;
      cursor: pointer;
      user-select: none;
      i {
        font-size: 30px;
        line-height: 24px;
        padding: 8px;
        color: #50708c;
      }
    }
    .center {
      line-height: 80px;
      font-size: 20px;
      font-weight: 600;
      color: #475669;
    }
    .img {
      height: 50px;
      width: 50px;
    }
  }
  main {
    width: 100%;
    max-width: 1080px;
    min-width: 846px;
    margin: 0 auto;
    .menu-title {
      width: 100%;
      margin: 10px auto;
      height: 60px;
      line-height: 60px;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      li {
        list-style: none;
        color: #333333;
        cursor: default;
      }
      .color {
        text-shadow: 0 0 20px #efa1a6;
        color: #ea7d4b;
      }
    }
    section {
      margin: 0 auto;
      flex: 1;
      padding: 20px 30px;
      background-color: #ffffff;
      .el-tabs {
        /deep/ .is-active {
          color: #ea7d4b;
        }
        /deep/ .el-tabs__active-bar {
          background-color: #ea7d4b;
        }
        /deep/ .el-tabs__item:hover {
          color: #ea7d4b;
        }
        .el-tab-pane {
          .seach {
            height: 40px;
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
            .el-input {
              width: 200px;
            }
          }
          .content {
            display: flex;
            flex-wrap: wrap;
            padding: 20px 10px;
            margin-bottom: 20px;
            border-bottom: 1px solid #cccccc;
            .item {
              font-size: 14px;
              width: 210px;
              // height: 140px;
              box-shadow: 0 0 4px #dddddd;
              border-radius: 5px;
              padding: 10px;
              position: relative;
              margin-right: 10px;
              margin-bottom: 10px;
              .imageBox {
                display: flex;
                align-items: center;
                width: 210px;
                max-height: 300px;
                overflow: hidden;
              }
              img {
                width: 210px;
                // height: 140px;
                cursor: pointer;
              }
              .cancel {
                position: absolute;
                top: 0;
                right: 0;
                width: 24px;
                height: 24px;
                font-size: 20px;
                border-radius: 50%;
                box-shadow: 0 0 9px 3px #ccc;
                background-color: rgba(255, 255, 255, 1);
                line-height: 23px;
                text-align: center;
                cursor: pointer;
              }
              .is_collect {
                color: #f4ea2a;
              }
            }
          }
          .recommend {
            .title {
              padding: 20px 0;
              color: #444;
            }
            .recommend_content {
              img {
                width: 210px;
                height: 140px;
                margin-right: 10px;
              }
            }
          }
        }
      }

      .myDown {
        padding: 5px 10px;
        .seach {
          height: 50px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #cccccc;
          span {
            font-size: 14px;
            color: #666666;
          }
        }
        .content {
          padding: 20px 0;
          .item {
            height: 80px;
            box-shadow: 0 0 8px #cccccc;
            display: flex;
            margin-bottom: 15px;
            cursor: pointer;
            .img {
              height: 80px;
              width: 80px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-right: 1px solid #ccc;
              img {
                width: 40px;
                height: 40px;
              }
            }
            .right {
              flex: 1;
              display: flex;
              padding: 5px 10px;
              align-items: center;
              .text {
                flex: 1;
                color: #444444;
              }
              .icon {
                width: 80px;
                display: flex;
                justify-content: center;
                align-items: center;
                i {
                  padding: 0 10px;
                  font-size: 20px;
                  cursor: pointer;
                }
                i:hover {
                  color: #ea7d4b;
                }
              }
            }
          }
        }
      }
    }
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
// 搜索框样式
.box_seach {
  .el-select {
    width: 100px;
    /deep/.el-input__inner {
      border: none;
      outline: none;
    }
  }
}
.file {
  .el-collapse .el-collapse-item__header {
    border: none;
  }
}
</style>
